var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form",
    {
      staticClass: "login-form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.onSubmit.apply(null, arguments)
        },
      },
    },
    [
      !_vm.formState.processing &&
      (_vm.formState.message.length > 0 || _vm.formState.success)
        ? _c(
            "b-alert",
            { attrs: { variant: _vm.formAlertType, show: "" } },
            [
              _vm.formState.success
                ? [
                    _c("p", [
                      _vm._v("Your password has been successfully updated"),
                    ]),
                  ]
                : [
                    _vm._v(
                      "\n      " + _vm._s(_vm.formState.message) + "\n    "
                    ),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Email address" } },
        [
          _c("b-form-input", {
            attrs: {
              type: "text",
              placeholder: "Email address",
              state: _vm.emailInvalid,
            },
            model: {
              value: _vm.formData.email,
              callback: function ($$v) {
                _vm.$set(
                  _vm.formData,
                  "email",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "formData.email",
            },
          }),
          _vm._v(" "),
          _c(
            "b-form-invalid-feedback",
            { attrs: { state: _vm.emailInvalid } },
            [_vm._v("\n      " + _vm._s(_vm.formValidation.email) + "\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "New password" } },
        [
          _c("b-form-input", {
            attrs: {
              type: "password",
              placeholder: "Enter new password",
              state: _vm.emailInvalid,
            },
            model: {
              value: _vm.formData.password,
              callback: function ($$v) {
                _vm.$set(
                  _vm.formData,
                  "password",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "formData.password",
            },
          }),
          _vm._v(" "),
          _c(
            "b-form-invalid-feedback",
            { attrs: { state: _vm.passwordInvalid } },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.formValidation.password) + "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Confirm New password" } },
        [
          _c("b-form-input", {
            attrs: {
              type: "password",
              placeholder: "Enter new password again",
            },
            model: {
              value: _vm.formData.password_confirmation,
              callback: function ($$v) {
                _vm.$set(
                  _vm.formData,
                  "password_confirmation",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "formData.password_confirmation",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          staticClass: "login-submit",
          attrs: {
            type: "submit",
            variant: "primary",
            block: "",
            disabled: _vm.formState.processing,
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(!_vm.formState.processing ? "Submit" : "Processing...") +
              "\n  "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }